import React from 'react';
import classnames from 'classnames';
import * as styles from './styles.module.scss';
import Icon from 'components/UI/Icon';

const Benefits = ({ data }) => (
  <div>
    <div className={styles.benefits_top}>
      <h2 className={classnames('cr-h2', styles.benefits_title)}>
        {data.title}
      </h2>
    </div>

    <div className={styles.benefits_main}>
      <ul className={classnames('cr-reg', styles.table)}>
        <span
          className={classnames(
            styles.table_grad,
            styles.table_grad_traditional
          )}
        ></span>
        <span
          className={classnames(styles.table_grad, styles.table_grad_cirrus)}
        ></span>

        <li className={styles.table_tr}>
          <span
            className={classnames(
              styles.table_td,
              styles.table_th,
              styles.table_td_name
            )}
          ></span>
          <span
            className={classnames(
              'cr-lead',
              styles.table_td,
              styles.table_th,
              styles.table_td_traditional
            )}
          >
            <span>
              <span className="cr-txt-medium">Traditional POS</span> systems
            </span>
          </span>
          <span
            className={classnames(
              'cr-lead',
              styles.table_td,
              styles.table_th,
              styles.table_td_cirrus
            )}
          >
            <span>
              <Icon name="cirrus-logo-black" className="cr-lead" /> Сloud-based
              POS
            </span>
          </span>
        </li>

        {data.benefits.map((row, i) => (
          <li key={i} className={styles.table_tr}>
            <span className={classnames(styles.table_td, styles.table_td_name)}>
              <i className={classnames('cr-text-1', styles.table_td_name_icon)}>
                <img src={row.iconSrc} alt="" />
              </i>
              <span className={classnames('cr-txt-medium')}>{row.name}</span>
            </span>
            <span
              className={classnames(
                styles.table_td,
                styles.table_td_traditional
              )}
            >
              <span
                dangerouslySetInnerHTML={{ __html: row.traditional }}
              ></span>
            </span>
            <span
              className={classnames(styles.table_td, styles.table_td_cirrus)}
            >
              <span dangerouslySetInnerHTML={{ __html: row.cirrus }}></span>
            </span>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

export default Benefits;
